import { Injectable } from "@angular/core";

@Injectable()
export class Helper {

    constructor() {

    }

    pwos() {
        return '{"pwos":[{"code":"1A1","endDate":"","description":"AUDIO HEAD","typeId":"1","label":"AUDIO HEAD","row_id":"2394","startDate":"2019-06-11","status":"DRAFT","typeCode":"Commodity"},{"code":"1B1","endDate":"","description":"SPEAKER","typeId":"1","label":"SPEAKER","row_id":"2327","startDate":"2019-06-11","status":"DRAFT","typeCode":"Commodity"},{"code":"1C1","endDate":"","description":"SPEAKER/PREMIUM : INCL. CABASSE & BOSE","typeId":"1","label":"SPEAKER/PR","row_id":"2328","startDate":"2019-06-11","status":"DRAFT","typeCode":"Commodity"},{"code":"1D1","endDate":"","description":"ANTENNA","typeId":"1","label":"ANTENNA","row_id":"2329","startDate":"2019-06-11","status":"DRAFT","typeCode":"Commodity"}]}'
        
    }
}
